"use strict";

import { commonConstants } from "../_constants";

export const getBankListRequest = (payload) => {
  return {
    type: commonConstants.BANK_LIST_REQUEST,
    payload,
  };
};

export const getBankListComplete = (payload) => {
  return {
    type: commonConstants.BANK_LIST_COMPLETE,
    payload,
  };
};

export const resetBankList = () => {
  return {
    type: commonConstants.RESET_BANK_LIST,
  };
};
export const setFirstTimeLoginState = (payload) => {
  return {
    type: commonConstants.SET_FIRST_TIME_LOGIN_STATE,
    payload,
  };
};

export const clearCommonErrors = () => {
  return {
    type: commonConstants.CLEAR_CUSTOM_ERRORS,
  };
};

export const setCommonHasChangeForm = (payload) => {
  return {
    type: commonConstants.COMMON_HAS_CHANGED_FORM,
    payload,
  };
};
